import axios from "axios";
import { serverBaseUrl } from "./apiConstants";
import * as Sentry from "@sentry/react";

const apiEndPoints = {
  getDesoProfile: "/tweets/get-deso-profile",
  postTweet: "/tweets/post-tweet",
  getScreenshot: "/tweets/get-screenshot",
  currentSubscription: "/real-time-sync/get-current-subscriptions",
  unsubscribeSubscription: "/real-time-sync/unsubscribe",
  changeSubscription: "/real-time-sync/change-subscription-type",
  getTweet: "/tweets/get-recent-tweets-from-username-temp",
  getDesoBalance: "/tweets/get-deso-for-user",
  isTransactionPossible: "/tweets/is-transaction-possible",
  postSelectedTweets: "/tweets/post-selected-tweets",
  getDerivedKeyStatus: "/real-time-sync/get-derived-key-status",
  createSubscription: "/real-time-sync/create-subscription",
  selectedTweetsTransfer: "/real-time-sync/selected-tweets-transfer",
  getAvailableSelected: "/real-time-sync/get-available-selected-tweets-count",
  getDesoProfileImage: "/tweets/get-user-profile-image/",
  getInstagram: "/instagram/",
  logoutInstagram: "/logout_instagram/",
  checkDesoUserName: "/deso/check-username-exists",
  updateDesoProfile: "/deso/update-deso-profile",
  getUserGlobalMedia: "/deso/get-user-global-metadata",
  getFollow: "/deso/get-people-to-follow",
  followUser: "/deso/follow-user",
  sendDeso: "/deso/lngXWyUuQL",
  getDataforProfilePage: "/deso/get-data-for-profile-page",
  dummyApi: "/real-time-sync/dummy",
  logoutWordpress: "/logout",
  currentSubscriptionWordpress: "/wordpress/get-current-subscriptions",
  unsubscribeSubscriptionWordpress: "/wordpress/unsubscribe",
  twitterCred: "/tweets/twitter-cred",
  getWaterMark: "/real-time-sync/get-water-mark-status",
  changeWaterMark: "/real-time-sync/change-water-mark-status",
};

export const getWaterMarkApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.getWaterMark,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const changeWaterMarkApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.changeWaterMark,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};

export const TwitterCredApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.twitterCred,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};

export const unsubscribeWordApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.unsubscribeSubscriptionWordpress,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};

export const getCurrentSubWordpressApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.currentSubscriptionWordpress,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};

export const getDesoProfileImageApi = async (key) => {
  try {
    const res = await axios.get(
      serverBaseUrl + apiEndPoints.getDesoProfileImage + key,
      {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const postDummyApi = async (body) => {
  try {
    const res = await axios.post(serverBaseUrl + apiEndPoints.dummyApi, body);
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const getAvailableSelectedApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.getAvailableSelected,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const selectedTweetsTransferApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.selectedTweetsTransfer,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const postSelectedTweetsApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.postSelectedTweets,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const getDesoBalanceApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.getDesoBalance,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const getTweetApi = async (body) => {
  try {
    const res = await axios.post(serverBaseUrl + apiEndPoints.getTweet, body);
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const isTransactionPossibleApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.isTransactionPossible,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const createSubscriptionApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.createSubscription,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const getDerivedKeyStatusApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.getDerivedKeyStatus,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const getScreenshotApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.getScreenshot,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error({ err });
  }
};
export const getDesoProfileApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.getDesoProfile,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    // Sentry.captureMessage(message);
    // Sentry.captureException(message);
  }
};
export const postTweetApi = async (body) => {
  try {
    const res = await axios.post(serverBaseUrl + apiEndPoints.postTweet, body);
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const currentSubscriptionApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.currentSubscription,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
  }
};
export const changeSubscriptionApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.changeSubscription,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const unsubscribeSubscriptionApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.unsubscribeSubscription,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const getInstagramApi = async () => {
  try {
    const res = await axios.get("https://web3setu.co.in/instagram/");
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const logoutWordpressApi = async () => {
  try {
    const res = await axios.get(serverBaseUrl + apiEndPoints.logoutWordpress);
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const logoutInstagramApi = async () => {
  try {
    const res = await axios.get(serverBaseUrl + apiEndPoints.logoutInstagram);
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const checkDesoUserNameApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.checkDesoUserName,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const updateDesoProfileApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.updateDesoProfile,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const getUserGlobalMediaData = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.getUserGlobalMedia,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const getFollowApi = async () => {
  try {
    const res = await axios.get(serverBaseUrl + apiEndPoints.getFollow);
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const followUserApi = async (body) => {
  try {
    const res = await axios.post(serverBaseUrl + apiEndPoints.followUser, body);
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const sendDesoApi = async (body) => {
  try {
    const res = await axios.post(serverBaseUrl + apiEndPoints.sendDeso, body);
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
export const getDataforProfilePageApi = async (body) => {
  try {
    const res = await axios.post(
      serverBaseUrl + apiEndPoints.getDataforProfilePage,
      body
    );
    return res.data;
  } catch (err) {
    let message = { err };
    Sentry.captureException(message);
    console.error(err);
  }
};
